import React from "react";
import { pushEventToDataLayer } from "../../helper/datalayer-utils";
import Logo from "../icons/logo";
import Google from "../social-media-icons/Google";
import "./custom-widget.m.css";

const CustomWidget = () => {
  const handleGooglePreferred = () => {
    console.log("Google Preferred Sources clicked");
    window.open("https://google.com/preferences/source?q=deccanherald.com", "_blank");
    if (window?.dataLayer) pushEventToDataLayer("google_pref_banner");
  };
  return (
    <div styleName="google-preferred-banner" onClick={handleGooglePreferred}>
      <div styleName="banner-header">
        <div styleName="banner-content-wrapper">
          {/* Left Content */}
          <div styleName="banner-left-content">
            <div styleName="banner-line-1">
              <span styleName="add-text">Add</span>
              <Logo width="45" height="40" />
              <span styleName="banner-text">as your preferred</span>
            </div>
            <div styleName="banner-line-2">
              <span styleName="banner-text">news source on Google</span>
            </div>
          </div>

          {/* Right Button */}
          <button styleName="google-add-btn">
            <Google />
            <span styleName="add-text">Add Now</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomWidget;
